/**
 * The only symbol the `features/air` root data layer left behind.
 *
 * (Three concept-owned files — `case-status-preset`, `case-conclusion-preset`,
 * `policy-vocabulary` — also still sit at the root. They are not data-layer
 * symbols and were deliberately left out of B2's scope; they should follow
 * their concepts in a later pass.)
 *
 * Every concept's key factory (`caseKeys`, `policyKeys`, `automationKeys`) and
 * every mutation-key factory prefixes with this, so a caller that wants to drop
 * the whole Platform's cache can still say
 * `invalidateQueries({ queryKey: AIR_ROOT_KEY })` without importing a concept
 * it does not otherwise care about.
 *
 * It stays here rather than in any one child because the alternative is two
 * concepts importing each other for a two-element tuple.
 */
export const AIR_ROOT_KEY = ['air'] as const
